import React, { useState, useEffect, createContext, useCallback } from 'react';
import { environment } from '../../utils';
import Cookie from 'universal-cookie';

const WS_URL = environment.REACT_APP_BACKEND_WS_URL;

export const SocketContext = createContext(null);

const cookie = new Cookie();

const SocketProvider = ({ children }) => {
  const jwt = cookie.get('jwt');
  const URL = jwt ? `${WS_URL}?authorization=${jwt}` : WS_URL;
  const [connection, setConnection] = useState(() => new WebSocket(URL));

  const reconnect = useCallback(() => {
    console.log('Reconnecting WebSocket...');
    setConnection(new WebSocket(URL));
  }, [URL]);

  useEffect(() => {
    connection.onopen = () => {
      console.log('WebSocket connection established');
    };
    connection.onerror = (evt) => {
      console.log(`WebSocket error. Data: ${evt.data}`);
    };
    connection.onclose = () => setTimeout(reconnect, 1000);
    return () => {
      connection.close();
    };
  }, [reconnect, connection]);

  return (
    <SocketContext.Provider value={connection}>
      {children}
    </SocketContext.Provider>
  );
};

export default SocketProvider;
